import { SETTING_PAGE_TYPE } from "../constants";

export const METHOD_TYPE = {
   MANUAL: 1,
   AUTO: 2,
   LIVE: 3
};

export const COMMENT_TYPE = {
   FULL_KEYWORD: 1,
   ONLY_KEYWORD: 2,
};

export const ORDER_TIME_CHECKOUT_TYPE_TODAY = [
   {
      type: 'AfterTime',
      name: 'Trong ngày'
   },
   {
      type: 'AfterDayTime',
      name: 'Ngày hôm sau'
   }
];

export const ORDER_TIME_CHECKOUT_TYPE_AFTER_DAY = [
   {
      type: 'AfterOneDay',
      name: 'Sau 1 ngày'
   },
   {
      type: 'AfterThreeDay',
      name: 'Sau 3 ngày'
   },
   {
      type: 'AfterFiveDay',
      name: 'Sau 5 ngày'
   },
   {
      type: 'AfterSevenDay',
      name: 'Sau 7 ngày'
   }
];

const settingPostsReducer = (state = {
   button_add_cart: '',
   button_view_cart: '',
   has_ask_phone_number: '',
   has_private_reply_address: '',
   has_use_form_address: '',
   is_buying_guide: '',
   is_combine_orders: '',
   is_reply_comment: 0,
   message_add_cart: '',
   message_comment_order: '',
   message_guide: '',
   type: METHOD_TYPE.MANUAL,
   type_comment: METHOD_TYPE.TYPE_1,
   has_message_out_of_stock: 0,
   limit_comment_post: 0
}, action) => {
   switch (action.type) {
      case SETTING_PAGE_TYPE.FETCH:
         return action.payload;
      case SETTING_PAGE_TYPE.SET_METHOD:
         return {
            ...state,
            type: action.payload
         };
      case SETTING_PAGE_TYPE.SET_TYPE_COMMENT:
         return {
            ...state,
            type_comment: action.payload
         };
      case SETTING_PAGE_TYPE.SET_MESSAGE_ADD_CART:
         return {
            ...state,
            message_add_cart: action.payload
         };
      case SETTING_PAGE_TYPE.SET_BUTTON_ADD_CART:
         return {
            ...state,
            button_add_cart: action.payload
         };
      case SETTING_PAGE_TYPE.SET_MESSAGE_CONFIRM_CART:
         return {
            ...state,
            message_confirm_cart: action.payload
         };
      case SETTING_PAGE_TYPE.SET_BUTTON_VIEW_CART:
         return {
            ...state,
            button_view_cart: action.payload
         };
      case SETTING_PAGE_TYPE.SET_CONTENT_MESSAGE_OUT_OF_STOCK:
         return {
            ...state,
            content_message_out_of_stock: action.payload
         };
      case SETTING_PAGE_TYPE.SET_MESSAGE_GUIDE:
         return {
            ...state,
            message_guide: action.payload
         };
      case SETTING_PAGE_TYPE.SET_IS_BUYING_GUIDE:
         return {
            ...state,
            is_buying_guide: action.payload
         };
      case SETTING_PAGE_TYPE.SET_HAS_MESSAGE_OUT_OF_STOCK:
         return {
            ...state,
            has_message_out_of_stock: action.payload
         }
      case SETTING_PAGE_TYPE.SET_LIMIT_COMMENT_POST:
         return {
            ...state,
            limit_comment_post: action.payload
         }
      case SETTING_PAGE_TYPE.SET_IS_REPLY_COMMENT:
         return {
            ...state,
            is_reply_comment: action.payload
         }
      case SETTING_PAGE_TYPE.SET_MESSAGE_COMMENT_ORDER:
         return {
            ...state,
            message_comment_order: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_ADD_PRODUCT_TO_DRAFT_ORDERS:
         return {
            ...state,
            has_add_product_to_draft_orders: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_PRIVATE_REPLY_ADDRESS:
         return {
            ...state,
            has_private_reply_address: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_ASK_PHONE_NUMBER:
         return {
            ...state,
            has_ask_phone_number: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_COMMENT_WELCOME_START_LIVE:
         return {
            ...state,
            has_comment_welcome_start_live: action.payload
         }
      case SETTING_PAGE_TYPE.SET_CONTENT_COMMENT_WELCOME_START_LIVE:
         return {
            ...state,
            content_comment_welcome_start_live: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_COMMENT_INTRO_PRODUCT:
         return {
            ...state,
            has_comment_intro_product: action.payload
         }
      case SETTING_PAGE_TYPE.SET_CONTENT_COMMENT_INTRO_PRODUCT:
         return {
            ...state,
            content_comment_intro_product: action.payload
         }
      case SETTING_PAGE_TYPE.SET_AUTO_COMPLETE_LIVE_CAMPAIGN:
         return {
            ...state,
            auto_complete_live_campaign: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_LOCK_COMMENT_CLOSE_SALE:
         return {
            ...state,
            has_lock_comment_close_sale: action.payload
         }
      case SETTING_PAGE_TYPE.SET_IS_NOT_INCREASE_QUANTITY_CART_ITEM:
         return {
            ...state,
            is_not_increase_quantity_cart_item: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_ORDER_TIME_CHECKOUT:
         return {
            ...state,
            has_order_time_checkout: action.payload
         }
      case SETTING_PAGE_TYPE.SET_ORDER_TIME_CHECKOUT_TYPE:
         return {
            ...state,
            order_time_checkout_type: action.payload
         }
      case SETTING_PAGE_TYPE.SET_LIMIT_TIME_ORDER_CHECKOUT:
         return {
            ...state,
            limit_time_order_checkout: action.payload
         }
      case SETTING_PAGE_TYPE.SET_HAS_REMINDER_CHECKOUT:
         return {
            ...state,
            has_reminder_checkout: action.payload
         }
      case SETTING_PAGE_TYPE.SET_CONTENT_REMINDER_CHECKOUT:
         return {
            ...state,
            content_reminder_checkout: action.payload
         }
      case SETTING_PAGE_TYPE.SET_REMINDER_CHECKOUT_TIMES:
         return {
            ...state,
            reminder_checkout_times: action.payload
         }
      case SETTING_PAGE_TYPE.SET_BUTTON_REMINDER_CHECKOUT:
         return {
            ...state,
            button_reminder_checkout: action.payload
         }
      default:
         return state;
   }
};

export default settingPostsReducer;